/* istanbul ignore file */
import React from 'react';
import { Show } from 'framework/show';
import { useOpportunityId } from 'domain/shared/opportunity';
import useOpportunityService from 'domain/sales/opportunity/opportunityService';

const ShowOpportunityContext = ({ children }: { children: React.ReactNode }) => {
  const { getById } = useOpportunityService() as any;
  const oppId = useOpportunityId();

  return <Show getDataMethod={() => getById(oppId)}>{children}</Show>;
};

export default ShowOpportunityContext;
